'use client'

import { use } from 'react'

import Swimlane from '@/app/[locale]/(worlds)/components/Swimlane'
import SectionSeparator from '@/components/SectionSeparator'
import { EditorChoice, Room } from '@/services/cms'

type DiscoverContentProps = {
  recommendWorldsPromise: Promise<Room[]>
  title: string
  collapseLabel: string
  expandLabel: string
}

export default function DiscoverContent({
  recommendWorldsPromise,
  title,
  collapseLabel,
  expandLabel,
}: DiscoverContentProps) {
  const recommendWorlds = use(recommendWorldsPromise)

  if (!recommendWorlds || recommendWorlds.length === 0) return null

  // Only `rooms` is accessed by Swimlane → AllWorldsCards
  const world = { rooms: recommendWorlds } as EditorChoice

  return (
    <>
      <SectionSeparator />
      <div className="px-4 md:px-8 lg:px-18">
        <Swimlane
          data-section="profile-discover-content"
          title={title}
          world={world}
          variant="contained"
          collapsible
          collapseLabel={collapseLabel}
          expandLabel={expandLabel}
        />
      </div>
    </>
  )
}
